define("StoreLocator.Search.View.Extension", [
  "StoreLocator.Search.View",
  "AjaxRequestsKiller",
  "Configuration",
  "underscore",
  "Ames.StoreLocator2.StoreLocator2.Model",
  "Utils",
], function defineWizardView(
  StoreLocatorSearchView,
  AjaxRequestsKiller,
  Configuration,
  _,
  StoreLocator2Model,
  Utils
) {
  _.extend(StoreLocatorSearchView.prototype, {
    initialize: _.wrap(
      StoreLocatorSearchView.prototype.initialize,
      function (fn) {
        // first call the original initialize
        fn.apply(this, Array.prototype.slice.call(arguments, 1));

        // our extra setup
        this.locatorModel = new StoreLocator2Model();

        localStorage.setItem("locationSelected", "");

        var openOnSaturday = Utils.getParameterByName(
          window.location.href,
          "openOnSaturday"
        );

        this.saturdayFilterApplied = openOnSaturday === "T" ? true : false;
        if (this.saturdayFilterApplied) {
          localStorage.setItem("filterOpenSaturday", "true");
        } else {
          localStorage.setItem("filterOpenSaturday", "false");
        }
      }
    ),
    useGeolocation: function useGeolocation() {
      this.reference_map.clearPointList();
      const self = this;

      this.$('[data-action="message-warning"]').hide();

      this.getCurrentPositionGeolocation().done(function () {
        self.findStores();
      });
    },

    selectLocationOption: function (e) {
      // get the id of the selected location
      var locationId = jQuery(e.currentTarget).data("location-id");
      // check if the target is selected
      if (jQuery(e.currentTarget).hasClass("selected")) {
        // remove the selected class
        jQuery(e.currentTarget).removeClass("selected");

        // get the selected options from local storage
        var optionsSelected = localStorage.getItem("locationSelected");
        // check if there are already selected options
        if (optionsSelected) {
          // parse the selected options
          var selectedOptions = JSON.parse(optionsSelected);
          // check if the location is already selected
          if (selectedOptions.indexOf(locationId) !== -1) {
            // remove the location from the selected options
            selectedOptions.splice(selectedOptions.indexOf(locationId), 1);
            localStorage.setItem(
              "locationSelected",
              JSON.stringify(selectedOptions)
            );
          }
        }
      } else {
        // add the selected class
        jQuery(e.currentTarget).addClass("selected");
        var optionsSelected = localStorage.getItem("locationSelected");
        // check if there are already selected options
        if (optionsSelected) {
          // parse the selected options
          var selectedOptions = JSON.parse(optionsSelected);
          // check if the location is already selected
          if (selectedOptions.indexOf(locationId) === -1) {
            // add the location to the selected options
            selectedOptions.push(locationId);
            localStorage.setItem(
              "locationSelected",
              JSON.stringify(selectedOptions)
            );
          }
        } else {
          // create a new array with the selected location
          var selectedOptions = [locationId];
          localStorage.setItem(
            "locationSelected",
            JSON.stringify(selectedOptions)
          );
        }
      }
    },
    findStores: function findStores(method, model, callbacks) {
      this.collection.reset();

      var position = this.reference_map.getPosition();

      if (position && position.address) {
        this.profileModel.set("storeLocator_last_search", position);

        return this.collection.update(
          {
            latitude: position.latitude,
            longitude: position.longitude,
            radius: this.reference_map.configuration.getRadius(),
            sort: "distance",
            page: "all",
            killerId: AjaxRequestsKiller.getKillerId(),
            reset: true,
            locationtype: Configuration.get(
              "storeLocator.defaultTypeLocations"
            ),
          },
          callbacks
        );
      }
    },
    // @method saveFormCustom Saves the form but preventing collision with google maps by using a timeout
    // @param {jQuery.Event} e jQuery event
    saveFormCustom: function saveFormCustom(e) {
      if ((e.type === "keypress" && e.keyCode === 13) || e.type === "submit") {
        e.preventDefault();
        e.stopPropagation();

        var self = this;
        var args = arguments;

        setTimeout(function () {
          self.saveForm.apply(self, args);
        }, 500);
      }
    },
    events: {
      'click [data-action="use-geolocation"]': "useGeolocation",
      "submit form": "saveFormCustom",
      'keypress [name="city"]': "saveFormCustom",
      'click [data-action="select-location-option"]': "selectLocationOption",
      'click [data-action="filter-open-saturday"]': "addSaturdayFilter",
    },
    addSaturdayFilter: function (e) {
      var isChecked = jQuery(e.currentTarget).is(":checked");
      if (isChecked) {
        localStorage.setItem("filterOpenSaturday", "true");
        console.log(
          "filterOpenSaturday set to true",
          localStorage.getItem("filterOpenSaturday")
        );
      } else {
        localStorage.setItem("filterOpenSaturday", "false");
        console.log(
          "filterOpenSaturday set to false",
          localStorage.getItem("filterOpenSaturday")
        );
      }
    },
    getContext: _.wrap(
      StoreLocatorSearchView.prototype.getContext,
      function (fn) {
        // delegate to the original getContext
        var context = fn.apply(this, Array.prototype.slice.call(arguments, 1));
        var locationSelected = localStorage.getItem("locationSelected");

        var self = this;

        context.saturdayFilterApplied = self.saturdayFilterApplied;

        
        // check if there are already selected options
        setTimeout(function () {
          if (locationSelected) {
            // parse the selected options
            var selectedOptions = JSON.parse(locationSelected);
            // check if there are already selected options
            if (selectedOptions.length > 0) {
              _.each(selectedOptions, function (locationId) {
                // check if the location is already selected
                if (
                  jQuery('[data-location-id="' + locationId + '"]').length > 0
                ) {
                  // add the selected class
                  jQuery('[data-location-id="' + locationId + '"]').addClass(
                    "selected"
                  );
                }
              });
            }
          }
        }, 500);
        return context;
      }
    ),
  });
});
